import styled, { css } from 'styled-components';

export const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.palette.primaryA6};
    z-index: 998;
    display: flex;
    justify-content: center;
    align-items: center;

    &.take-address-container {
        .corner-line {
            width: calc(100vw - 80px);
            height: calc(100% - 230px);

            ${(props) =>
                props.theme.isLandscape &&
                css`
                    ${props.theme.orientation.landscape} {
                      height: 'calc(100% - 80px)
                    }
                `}
        }
    }

    video {
        height: 100%;
        width: 100%;
        object-fit: fill;
        position: absolute;

        ${(props) =>
            props.theme.isLandscape &&
            css`
                ${props.theme.orientation.landscape} {
                    width: auto;
                }
            `}
    }

    .camera-preview {
        width: 100%;
        position: absolute;
    }

    .photo-img {
        width: 100%;
    }

    .spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .camera-mobile-actions {
        min-height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        position: absolute;
        bottom: 20px;
        left: 16px;
        right: 16px;

        ${(props) => props.theme.breakpointTo.sm} {
            justify-content: center;
        }

        .secondary-button {
            background-color: ${(props) => props.theme.palette.primaryA7};
            color: ${(props) => props.theme.palette.primaryA1};

            &:hover {
                background-color: ${(props) => props.theme.palette.primaryA1};
                color: ${(props) => props.theme.palette.primaryA7};
            }
        }
    }

    .take-photo-button {
        width: 32px;
        min-height: 32px;
        padding: 0;
        border-radius: 50%;
        border: none;
        background-color: rgb(255, 255, 255);
        cursor: pointer;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition:
            all,
            transform 0ms;

        &:after {
            content: '';
            position: absolute;
            width: 40px;
            height: 40px;
            border: 2px solid rgb(255, 255, 255);
            border-radius: 50%;
        }
    }

    .corner-line {
        max-width: 410px;
        width: calc(100% - 32px);
    }

    .hidden-input {
        opacity: 0;
        pointer-events: none;
    }
`;
export const Content = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    z-index: 999;
    width: 100%;
    height: 100%;
    padding: 32px 22px 16px 22px;

    ${(props) =>
        props.theme.isLandscape &&
        css`
            ${props.theme.orientation.landscape} {
                padding: 6px 22px 16px 22px;
            }
        `}
`;

export const Header = styled.div`
    .header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 32px;
        gap: 9px;

        .title {
            color: ${(props) => props.theme.palette.primaryA7};
            text-align: center;

            ${(props) => props.theme.breakpointTo.md} {
                font-size: 20px;
                line-height: 30px;
            }

            ${(props) => props.theme.breakpointTo.md} {
                text-align: left;
            }

            span {
                color: ${(props) => props.theme.palette.primaryA1};
                border-bottom: 1px solid ${(props) => props.theme.palette.primaryA1};
            }
        }
    }

    .arrow-icon {
        display: flex;
        transform: rotate(180deg);
        color: ${(props) => props.theme.palette.primaryA7};

        ${(props) =>
            props.theme.isLandscape &&
            css`
                ${props.theme.orientation.landscape} {
                    transform: rotate(180deg) scale(1.5);
                }
            `}

        svg {
            width: 24px;
            height: 24px;
        }
    }
`;
